export const rptFrequencyAnalysisDetail = (eventsData) => {
    let rptArr = [];
    let sortFreq = 0;
    for (let i=0; i<eventsData.length; i++){
        if (i === 0){
            const headingLine = {
                eventTitle: "Event Title",  gamePhase: "Game Phase", description: "Description",
                eventCategory: "Category",  careerTag: "Career", conditionArr: "Condition List",
                monthArr: "Month Arr",
                frequency: "Event Frequency", freqType: "FreqName", freqPriority: "FreqTier",
                eventID: "EventID", sortFreq: "Sort Number" };
            rptArr.push(headingLine);
        }
        const event = eventsData[i];
        let conditions = "";
        if (event.conditionArr){
            conditions = event.conditionArr.join(',');
        }
        if (event.frequency === "force"){
            sortFreq = 999;
        }else{
            sortFreq = event.frequency;
        }
        let freqType = "";
        let freqPriority = "";
        if (event.frequencyObj){
            freqType = event.frequencyObj.frequencyType;
            freqPriority = event.frequencyObj.freqPriority;
        }
        let monthsSelected = "";
        if (event.selectMonthArr){
            monthsSelected = event.selectMonthArr.join(',');
        }
        const detailRptLine = { eventTitle: event.title, gamePhase: event.gamePhase,
            description:  event.description, eventCategory: event.eventCategory, 
            careerTag: event.careerTag, conditionArr: conditions,
            monthArr: monthsSelected,
            frequency: event.frequency, freqType: freqType, 
            freqPriority: freqPriority, eventID: event.id, sortFreq: sortFreq}
        rptArr.push(detailRptLine);
            
    }
    rptArr.sort((a, b) => 
            (a.careerTag + +a.sortFreq > b.careerTag + +b.sortFreq) ? 1 : -1);
         
    return rptArr;
   
}
export default rptFrequencyAnalysisDetail;